import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { CaseBattlesCaseSelectionModalComponent } from '@features/games/case-battles/cb-case-selection-modal/cb-case-selection-modal.component';
import { CaseBattlesCaseSkinsModalComponent } from '@features/games/case-battles/cb-case-skins-modal/cb-case-skins-modal.component';

export function provideCaseBattlesModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'CaseBattlesCaseSelectionModalComponent', component: CaseBattlesCaseSelectionModalComponent }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'CaseBattlesCaseSkinsModalComponent', component: CaseBattlesCaseSkinsModalComponent }, multi: true },
  ];
}
